// ---------------------------------------------------------------------------//
//
// Toggle Class
//
// ----------------------------------------------------------------------------//

// ----------------------------------------------------------------------------//
// Attributes on trigger element:
// ----------------------------------------------------------------------------//
//
// data-behaviour="toggle-class"    - For setting up the click event
// data-target="element"            - For targeting another element
// data-class="trigger-class"       - Class to be toggled (optional)
// data-kill-overflow               - Stops the page scroll when active.
//                                    Pass an optional class name to toggle
//                                    on the html element (optional)
//
// ----------------------------------------------------------------------------//

// ----------------------------------------------------------------------------//
// Attributes on target element:
// ----------------------------------------------------------------------------//
//
// data-element="element"           - To match the triggers data-target
// data-class="target-class"        - Class to be toggled
//
// ----------------------------------------------------------------------------//

// ----------------------------------------------------------------------------//
// Usage:
// ----------------------------------------------------------------------------//
//
// import './modules/toggle-class'
//
// ----------------------------------------------------------------------------//

import { _ } from '../utils.js'

class ToggleClass {
    constructor() {
        document.addEventListener('click', this.toggleClass)
        this.html = document.querySelector('html')
        this.body = document.body
        this.scrollPos = 0
        this.scroll = true
    }

    toggleClass = (e) => {
        if (!(e.target && e.target.dataset.behaviour === 'toggle-class')) {
            return false
        }
        e.preventDefault()
        const trigger = e.target
        const target = _(trigger.dataset.target, 'element').node()
        const triggerClass = trigger.dataset.class
        const targetClass = target.dataset.class
        const killOverflow = trigger.getAttribute('data-kill-overflow')

        if (triggerClass) {
            trigger.classList.toggle(triggerClass)
        }

        if (typeof killOverflow === 'string') {
            this.toggleScroll(killOverflow || 'kill-overflow')
        }

        target.classList.toggle(targetClass)
    }

    /**
     * @param  {string} className
     */

    stopScroll = (className) => {
        this.scroll = false
        this.scrollPos = window.pageYOffset
        this.html.classList.add(className)
        this.body.style.height = window.outerHeight
        this.body.style.overflow = 'hidden'
        window.scrollTo(0, 0)
    }

    /**
     * @param  {string} className
     */

    startScroll = (className) => {
        this.scroll = true
        this.html.classList.remove(className)
        this.body.style.height = 'auto'
        this.body.style.overflow = 'auto'
        window.scrollTo(0, this.scrollPos)
    }

    /**
     * @param  {string} className
     */

    toggleScroll = (className) => {
        if (this.scroll) {
            this.stopScroll(className)
        } else {
            this.startScroll(className)
        }
    }
}

export default ToggleClass
